import { injectable, decorate, inject } from 'inversify';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';

@injectable()
class ListService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getSalesOrgs = async () => {
    const result = await this.apiService.get(`/sales_orgs`);
    return result.data.data.items;
  };

  getCompanies = async () => {
    const result = await this.apiService.get('/companies');
    return result.data.data.items;
  };

  getOffices = async () => {
    const result = await this.apiService.get('/offices');

    return result.data.data.items;
  };

  getCustomers = async (params) => {
    const result = await this.apiService.get('/customers_list', params);

    return result.data.data.items;
  };
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), ListService, 0);

export default ListService;
